import React, { useState, useEffect, useContext, StyleSheet } from "react";
import { Container, Tabs, Tab, Form, Col, Row, Button, Card, InputGroup, ProgressBar, Image } from "react-bootstrap";
import { Link, redirect, useNavigate } from "react-router-dom";

import { FaSketch } from "react-icons/fa";
import { AiOutlineSketch } from "react-icons/ai";

import { auth, firestore } from "../../../Database/firebase";
import { storage } from "../../../Database/firebase";
/* import OrderCustomer from "./OrderCustomer";
import Cart from "./Cart"; */

// import OrderHistory from "../../component_m/Order/OrderHistory";

//import OrderHistory from "./OrderHistory";

import { AuthContext } from "../../../Authentication/AuthProvider";
/* import OrderCustomerCart from "./OrderCustomerCart";
import OrderHistoryCart from "./OrderHistoryCart"; */

//import "./roundprofileimg.css";

import { BsStarFill, BsStarHalf, BsStar, BsPatchCheck, BsPlayBtn, BsPhone, BsFolder2Open, BsInfinity, BsCheckLg, BsPeopleFill, BsFillPlayBtnFill, BsChatLeftDotsFill, BsPersonCircle, BsCameraReels, BsRecordFill, BsEye, BsImage, BsEarFill, BsEyeFill, BsDisplay } from "react-icons/bs";




/* import MyArticle from "../../component_m/Article/MyArticle";
import BookmarkArticle from "../../component_m/Article/BookmarkArticle"; */

function Profile() {

    const navigate = useNavigate();

    const refreshPage = () => {
        navigate(0);
    }

    /* TEST QUERY DATA WITH productID */

    // const [uid, setUid] = useState("");

    const [currentUser, setCurrentUser] = useState(null);
    const authContext = useContext(AuthContext);

   //const [uid, setUid] = useState("");

    var user = auth.currentUser;
    // var uid = "";
    var uid = "";

    if (user != null) {
        //email = user.email;
        uid = user.uid;  // The user's ID, unique to the Firebase project. Do NOT use
                         // this value to authenticate with your backend server, if
                         // you have one. Use User.getToken() instead.
        console.log(uid);
        
        //TEST AUTH
        // refreshPage();
    } else {
        navigate("/");
    }


    

    // const [emailDefault, setEmailDefault] = useState("");

    // const [loading, setLoading] = useState(false);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phonenumber, setPhonenumber] = useState("");
    const [address, setAddress] = useState("");

    //const [created, setCreated] = useState(new Date());

    const [role, setRole] = useState("");
    const [sPoint, setSPoint] = useState("");

    const [displayName, setDisplayName] = useState("");

    var displayname = displayName;

    const [profession, setProfession] = useState("");
    const [description, setDescription] = useState("");

    const [socialPublic, setSocialPublic] = useState("");

    const socialPublicOption = ["สาธารณะ", "เฉพาะฉัน"];
    const [socialPublicString, setSocialPublicString] = useState(socialPublicOption[0]);


    const [facebook, setFacebook] = useState("");
    const [youtube, setYoutube] = useState("");
    const [instagram, setInstagram] = useState("");
    const [tiktok, setTiktok] = useState("");

    const [profileImg, setProfileImg] = useState("");

    const [file, setFile] = useState("");
    const [link, setLink] = useState("");

    const [resizefileUrl, setResizefileUrl] = useState("");

    const [data, setData] = useState([]);
    useEffect(() => {
    const userRef = firestore.collection("user");
    const query = userRef
    
        .where("uid", "==", uid);
            query
            .get()
            .then((querySnapshot) => {
                let tempDataArray =[];
                querySnapshot.forEach((doc) => {
                    if (doc.exists) {
                        console.log(doc.data());
                        tempDataArray = [...tempDataArray,
                        {
                            uid: doc.id,
                            name: doc.data().name,
                            email: doc.data().email,
                            phonenumber: doc.data().phonenumber,
                            address: doc.data().address,
                            sPoint: doc.data().sPoint,   
                            role: doc.data().role,
                            //created: doc.data().created,

                            displayName: doc.data().displayName,

                            profession: doc.data().profession,
                            description: doc.data().description,

                            socialPublic: doc.data().socialPublic,
                            facebook: doc.data().facebook,
                            youtube: doc.data().youtube,
                            instagram: doc.data().instagram,
                            tiktok: doc.data().tiktok,

                            profileImg: doc.data().profileImg,

                            
                        },
                        
                    ];

                    setName(doc.data().name);
                    setPhonenumber(doc.data().phonenumber);
                    setEmail(doc.data().email);
                    setAddress(doc.data().address);

                    //setCreated(doc.data().created);

                    setRole(doc.data().role)
                    setSPoint(doc.data().sPoint);

                    setDisplayName(doc.data().displayName);

                    setProfession(doc.data().profession);
                    setDescription(doc.data().description);

                    setSocialPublic(doc.data().socialPublic);
                    setFacebook(doc.data().facebook);
                    setYoutube(doc.data().youtube);
                    setInstagram(doc.data().instagram);
                    setTiktok(doc.data().tiktok);

                    setProfileImg(doc.data().profileImg);

                    setResizefileUrl(doc.data().profileImg);
                    

                    };

                });

            setData((oldDataArray) => tempDataArray);
            

        },

            (err) => {
                console.log(err);
            }
            
        );

    }, [uid]); 



    /////////////////////////////////////// CHECK ALREADY USER NAME /////////////////////////

    /* const [dataDisplayName, setDataDisplayName] = useState([]);
    const [checkDisplayName, setCheckDisplayName] = useState("");

    useEffect(() => {
        const userRef = firestore.collection("user");
        const query = userRef
        
            .where("displayName", "==", displayName);
                query
                .get()
                .then((querySnapshot) => {
                    let tempDataArray =[];
                    querySnapshot.forEach((doc) => {
                        if (doc.exists) {
                            console.log(doc.data());
                            tempDataArray = [...tempDataArray,
                            {
                                uid: doc.id,
                                displayName: doc.data().displayName,
                          
                            },
                            
                        ];
    
                    
                        setCheckDisplayName(doc.data().displayName);
            
    
                        };
    
                    });
    
                setDataDisplayName((oldDataArray) => tempDataArray);
                
    
            },
    
                (err) => {
                    console.log(err);
                }
                
            );
    
        }, [displayName]); */

    ////////////////////////////////////////////////////////////////////////////////////////



    const [progress, setProgress] = useState(1);
    const [progressStatus, setProgressStatus] = useState(false);

    const subBucketRef = storage.child("mainBucket/profileImage/" + uid);

    

    useEffect(() => {

        if (resizefileUrl == profileImg) {

            setResizefileUrl(profileImg);
            
        } else {
            setResizefileUrl(resizefileUrl);
           
        }

    }, [resizefileUrl]);

    
    const uploadHandler = (e) => {

        e. preventDefault();

        if (!!file) {

            const fileName = file.name;
            /* const metadata = {
                contentType: 'image/jpeg',
                firebaseStorageDownloadTokens: uid,
              }; */
            const targetRef = subBucketRef.child(fileName);

            // const extension = fileName.split(".").pop();
            const name = fileName.split(".").slice(0, -1).join(".");
            setResizefileUrl("https://firebasestorage.googleapis.com/v0/b/selpage-9425f.appspot.com/o/mainBucket%2FprofileImage%2F" + uid +"%2F" + name + "_" + "1000x1000" + "." + "jpeg" + "?alt=media");
            console.log(resizefileUrl);

           

            
            /* setLink(resizefileName);
            console.log(link); */
            
            

            const uploadTask = targetRef.put(file);
            // .putString(your_base64_image, ‘base64’, {contentType:’image/jpg’});
            setProgressStatus(true);

            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    setProgress((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                },
                (error) => {
                    console.log(error);
                },
                () => {
                    setProgressStatus(false);
                    uploadTask.snapshot.ref.getDownloadURL().then((photoURL) => {
                        console.log(photoURL);

                        setLink(photoURL);

                       /*  setLink(resizefileName);
                        console.log(link); */


                    });
                }
            );



        } else {
                console.log("no file upload!!");
        }

    };

    

    

    

    const editHandler = (obj) => {
        
        const ref = firestore.collection("user");
        ref
            .doc(uid)
            .update(obj)
            .then(() => {
                console.log("แก้ไขข้อมูลสำเร็จ");
                refreshPage();
            })
            .catch((err) => console.log(err));
    };

    const submitHandler = (e) => {
        e.preventDefault();

        const obj = {
            
            name : name,
            email : email,
            phonenumber : phonenumber,
            address: address,
            displayName: displayName,

            profession: profession,
            description: description,

            socialPublic: socialPublicString,
            facebook: facebook,
            youtube: youtube,
            instagram: instagram,
            tiktok: tiktok,

            

            profileImg: resizefileUrl,

        };
 
        setName("");
        setEmail("");
        setPhonenumber("");
        setAddress("");
        setDisplayName("");

        setProfession("");
        setDescription("");


        setFacebook("");
        setYoutube("");
        setInstagram("");
        setTiktok("");

        editHandler(obj);
    };

    const myStore = () => {
        if (role == "merchant") {
            navigate("/MerchantView")
        } else {
            alert("ร้านค้าของฉันพร้อมเปิดให้บริการเร็วๆ นี้, ขออภัยในความไม่สะดวก");
        }
    }

    const signOutHandler = () => {
        auth.signOut().then(() => {
            console.log("Log Out Ok");
            setCurrentUser(null);
            navigate("/");
        })
        .catch((err) => {
            console.log("Log Out Not Ok." + err);
        })
    };

    
 




            

            return (
                            
               

                    <Container>

                        { profileImg ? (
                        
                            <div className="d-flex justify-content-center align-items-center">
                                {/* <img class="image-cropper" src={profileImg} style={{ marginLeft: 'auto', marginRight: 'auto', textAlign: 'center', marginVertical: 15,  width: 80, height: 80, borderRadius: 80/2}}/> */}
                                <Image src={profileImg} style={{ marginLeft: 'auto', marginRight: 'auto', marginVertical: 15,  width: 80, height: 80, borderRadius: 80/2}}/>
                            </div>
                        ) : (
                        
                            <div
                                style={{marginLeft: 'auto', marginRight: 'auto', borderWidth: 1, backgroundColor: 'black', borderRadius: 80/2, width: 80, height: 80,}}
                            >
                                <p style={{marginLeft: 'auto', marginRight:'auto', marginTop: 'auto', marginBottom: 'auto', textAlign: 'center', fontSize: 50, fontWeight: 'bold', color: 'white'}}>{(email).slice("0", "1")}</p>
                            </div>
                                        
                        )}
                        
                        <p style={{textAlign: 'center', fontSize: 30, marginTop: 20,}}>{displayName}</p>
                        
                            {user ? (
                                <p style={{textAlign: 'center', marginLeft: 'auto', marginRight: 'auto', marginTop: 5, color: 'gray'}}>{email}</p>
                            ) : (
                                <p></p>
                            )}

                                <Card className="rounded-0">
                                    <Card.Header>
                                        <strong>ID : {uid}</strong>
                                    </Card.Header>

                                    <Card.Body>
                                            

                                        <Card.Text>
                                                                                    
                                            <strong>Username : {email}</strong><br/>
                                            <strong>ชื่อในระบบ : {displayName}</strong><br/>
                                            <strong>ชื่อ-นามสกุล : {name}</strong><br/>
                                            <strong>เกี่ยวกับฉัน : {description}</strong><br/>
                                            <strong>หมายเลขโทรศัพท์:</strong> {phonenumber}<br/>
                                            <strong>ที่อยู่ : {address}</strong><br/>
                                            <strong>Facebook : {facebook}</strong><br/>
                                            <strong>Instagram : {instagram}</strong><br/>
                                            <strong>Youtube : {youtube}</strong><br/>
                                            <strong>TikTok : {tiktok}</strong><br/>
                                            {/* <strong>สร้างเมื่อวันที่ : {(created).toDate().toLocaleDateString('th-TH', {year: 'numeric', month: 'short', day: 'numeric', weekday: 'short',})}</strong><br/> */}
                                                                                        
                                            {/* <strong>ราคาเต็ม:</strong> {item.productFullPrice}<br/>
                                            <strong>ส่วนลด:</strong> {item.productDiscount} %<br/>
                                            <strong>ราคาขาย:</strong> {item.productPrice}<br/>
                                            <strong>ขายในระบบ:</strong> {item.bookPlatform}<br/> */}

                                          
                                                                                  
                                        </Card.Text>
                                    </Card.Body>
                                </Card>

                       

                    <br/>
                    <br/>

                    </Container>
      

              
    );
}



export default Profile;